///<summary>
/// This Object contains the complete handling of the ReportSheets in js <br/>
/// it handles the adding and removing from and to the pdf and the database
///</summary>
function ReportSheets() {
 
}
ReportSheets.prototype = new window.vcTemplate();
ReportSheets.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler,  <br/>
    /// initializes the search <br/>
    /// and fills the list elements with the assignments
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.generateLists();
        me.initClickHandler(); 
          me.visual.find(".btn-add-to-excel,.btn-delete-from-db").button();
      
        me.wiz = $("#sheet-wizard").vcWizard({ stepWidth: 268 });
        me.visual.find("#filter-missing.vc-filter").vcFilter({ callback: function () { me.filter("#lst-missing", "#filter-missing"); } });
        me.visual.find("#filter-available.vc-filter").vcFilter({ callback: function () { me.filter("#lst-available", "#filter-available"); } });
        me.visual.find("#filter-used.vc-filter").vcFilter({ callback: function () { me.filter("#lst-used", "#filter-used"); } });
             
        me.visual.find(".vc-list-table .vc-list-item").filter(":even").addClass("alt");
        me.visual.find(".report-info-tooltip").tipTip();
        me.sendReportValidState(me.visual.find("#lst-missing li").length === 0);
        return true;
    } catch (ex) {
        me.writeError('ReportSheets.init', ex);
        return false;
    }
};
ReportSheets.prototype.sendReportValidState = function(valid) {
    var me = this;
    try {
        window._VCMQ.produce(me.visual, me.vcgid, "REP_CONFIG_VALID", { "valid": valid, "step": 4 });

    } catch (ex) {
        me.writeError('reportsheets.sendReportValidState', ex);

    }
};
ReportSheets.prototype.addSheetTitles = function () {
      /// <summary>
      /// This function calls the webservice to change the sheet options
     /// </summary>
    var me = this;
    try {
        me.visual.find("#lst-used").off("click", ".btn-save-sheet-option").on("click", ".btn-save-sheet-option", function () {
            var button = $(this);       
            window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, me.param, "", me.deviceType, me.langid, JSON.stringify(me.createOptionObject(3,button)), function (result) {
                if (result.hasError === false) {
                    button.siblings(".save-success").show(0);              
                    button.siblings(".save-success").delay(5000).hide(0);                   
                    button.hide();
                } else {
                    me.showInfo(result.retHTML, "", true);
                }
            });
        }
        );
    } catch (ex) {
        me.writeError('ReportSheets.addSheetTitles', ex);
    }
};
ReportSheets.prototype.deleteFromPdfOutput = function () {
     /// <summary>
      /// This function calls the webservice to remove the sheet from the pdf output
     /// </summary>
    var me = this;
    me.visual.find("#lst-used").on("click", ".btn-delete-sheet-option", function () {

                   var button = $(this);
                    var used = me.sheetList.filter(function(inList) {
                        return inList.dbId === button.data("id") && inList.excelName === button.data("name");
                    });

                    window.VisualCoreService.updateData(me.vcvid,me.vcgid,window.getCurrentTimestamp(),0,0,me.param,"",me.deviceType,me.langid,JSON.stringify(me.createOptionObject(5, button)),function(result) {
                            if (result.hasError === false) {
                                button.parents("li").remove();
                                me.generateAvailableElements(used, me.visual.find("#lst-available"));
                            } else {
                                me.showInfo(result.retHTML, "", true);
                            }
                        });

                });
   
};
ReportSheets.prototype.createListDivs = function (sListName, sListCaption, sListHelp, sListSizeClass) {
    ///<summary>
    /// Helper function to create the outer list elements
    ///</summary>

    var me = this;
    var list, divListHolder, divOuterList;
    try {
        divOuterList = $("<div>", { 'class': "" + sListSizeClass + "", 'style': "float:left; margin-right:18px;height:"+me.visual.height() +"px;", "html": "<div class='note'>" + sListHelp + "</div><div style='clear:both; height:12px;' ></div>" });
     divListHolder = $("<div>",
            {
                'id': "div-" + sListName,
                'class': "vc-list " + sListSizeClass + "",
                'html': "<div class='caption'>" + sListCaption + "</div><div id='filter-" + sListName + "' class='vc-filter'></div><div class='report-filter-checkbox'><input class='report-list-checkbox'  id='chb-" + sListName + "' type='checkbox'> " + me.resources.showInternalSheets+"</div><hr/>"
         }).appendTo(divOuterList);
       list = $("<ul>",
            {
                'id': 'lst-'+sListName,
                'class': 'vc-list-selection'

            }).appendTo(divListHolder);
        divOuterList.appendTo(me.visual);
    } catch (ex) {
        me.writeError('ReportSheets.createListDivs', ex);
        return null;
    }
    return list;
};
ReportSheets.prototype.generateLists = function () {
    ///<summary>
    /// Helper function that calls all subfunction that create the list items
    ///</summary>
    var me = this;
    var sizeClass = 'vc-grid-3col';
    try {
        if (window.screen.width < 1400) {
            sizeClass = 'vc-grid-2col';
            
        }
        me.generateAvailableElements(me.sheetList.filter(function (element) { return element.available === true && element.bInUse === false || element.bInUse === true && element.bInternal === true; }), me.createListDivs("available", me.resources.availableListCaption, me.resources.lstAvailableHelp, sizeClass));
        me.generateUsedElements(me.sheetList.filter(function (element) { return element.available === true && element.bInUse === true && element.bInternal === false; }), me.createListDivs("used", me.resources.usedListCaption, me.resources.lstUsedHelp, "vc-grid-3col"));
        me.generateMissingElements(me.sheetList.filter(function (element) { return element.available === false; }), me.createListDivs("missing", me.resources.errorListCaption, me.resources.lstMissingHelp, sizeClass));
       
    } catch (ex) {
        me.writeError('ReportSheets.generateLists', ex);
    }
};
ReportSheets.prototype.createListElements = function (sheet, sHTML) {
    ///<summary>
    /// this function creates the vc-list items
    ///</summary>
    var me = this;
    var listItem, desc = "", toolTip = "", toolTipText = "";
    try {
        if (sheet.description) {
            toolTip = "report-info-tooltip";
            desc = " <i class='fa fa-info fa-lg icon-color-info'></i>";
            toolTipText = "title='" + sheet.description + "'";
        }

        listItem = $("<li>",
            {
                'class': 'vc-list-item',
                'value': sheet.excelName,
                'data-internal': sheet.bInternal,
                'data-excelindex': sheet.excelSorting,
                'html': "<div class='excel'><div class='excel-sheet-name " +toolTip +"'"+toolTipText+">" + sheet.excelName + desc + "</div>" + sHTML + "</div>"
            });
    } catch (ex) {
        me.writeError('ReportSheets.createListElements', ex);
        return null;
    }
    return listItem;
};
ReportSheets.prototype.generateUsedElements = function (listElements, list) {
    ///<summary>
    /// Helper function to build the vc list item for the used list
    ///</summary>
    var me = this;
    var sHTML;
    var listElement;
    try {

        listElements.forEach(function (element) {

            sHTML = "<i class='btn-delete-sheet-option icon-color-error fa fa-trash fa-2x' data-excelindex='" + element.excelSorting +"' data-id='" + element.dbId + "' data-name='" + element.excelName + "' title='" + me.resources.deleteFromPDF + "'></i>";
            sHTML += "<i class='fa fa-check icon-color-ok fa-2x save-success' title='" + me.resources.saveSucess+"' style='display:none; float:right; margin-right:5px;'></i><i  style='display:none; margin-right:5px;' class='btn-save-sheet-option fa fa-save fa-2x icon-color-info' data-id='" + element.dbId + "' data-name='" + element.excelName + "' title='" + me.resources.save + "'></i>";

            if (element.bInternal === false) {
                sHTML += "<div class='excel-options'>";
            } 
            if (element.headers === null) {
                element.headers = { 2: element.excelName, 3: element.excelName };
            }

            if (element.headers !== null) {
                var sIcon = "";
                
                for (var i = 2; i <= 3; i++) {
                   sHTML += $("<div>",
                        {
                            "class": "excel-header-title",
                            "html": "<div class='excel-option'><div class='report-title-name'>"+ me.getLanguageText(i) +"</div><input class='excel-header-value txtEnabled input' type='text' data-langid='" +i +"' value='" +element.headers[i] +"'></div>"
                        }).html();
                }
                if (element.bAutoDate === true) sIcon = "checked='checked'";
                sHTML += $("<div>",
                    {
                        "class": "excel-header-title",
                        html: "<div class='excel-option excel-option-checkbox' ><input type='checkbox' " + sIcon + " class='icon-checkbox'/><div class='checkbox-text'>" + me.resources.addEndDate + "</div></div>"
                    }).html();
            }
            sHTML += "<div class='excel-option'>";

            sHTML += "</div>";
          
            sHTML += "</div>";
            listElement = me.createListElements(element, sHTML);
            listElement.appendTo(list);
        });

            list.html(list.find(".vc-list-item").sort(function(a, b) {
                return me.sortSheets(me, a, b);
        }));
     
    } catch (ex) {
        me.writeError('ReportSheets.generateUsedElements', ex);

    }
};
ReportSheets.prototype.generateAvailableElements = function (listElements, list) {
    ///<summary>
    /// Helper function to build the vc list item for the available list
    ///</summary>
    var me = this;
    var listElement;
    try {
        
        listElements.forEach(function(element) {
            listElement = me.createListElements(element, "<i class='btn-add-sheet-to-pdf fa fa-arrow-right fa-2x icon-color-info' data-id='" + element.dbId + "' data-name='" + element.excelName + "' title='" + me.resources.btnAddToPdf +" data-excelindex='" + element.excelSorting +"'></i>");
            listElement.appendTo(list); 
        });
        list.find("li[data-internal='true']").find(".btn-add-sheet-to-pdf").replaceWith("<div class='small'>" + me.resources.notShownInPDF + "</div>");
        list.html(list.find(".vc-list-item").sort(function (a, b) {
            return me.sortSheets(me, a, b);
        }));

    } catch (ex) {
        me.writeError('ReportSheets.generateAvailableElements', ex);

    }
};
ReportSheets.prototype.generateMissingElements = function (listElements, list) {
    ///<summary>
    /// Helper function to build the vc list item for the missing(error) list
    ///</summary>
    var me = this;
    var listElement;
    var sHTML;

    try {
        listElements.forEach(function (element) {
            if (element.bInternal === false && element.bNeeded === false) {
                sHTML = "<div class='note' style='float:left;'>" + me.resources.availableForDeletion + " <div class='btn-delete-from-db' style='float:right;' data-id='" + element.dbId + "'>" + me.resources.delete + "</div></div>";
            } else {
                sHTML = "<div class='note' style='float:left;'>" + me.resources.neededForExport + "<div class='btn-add-to-excel' data-name='" + element.excelName + "'>" + me.resources.addSheetToExcel + "</div> <div class='btn-delete-from-db' style='float:right;' data-id='" + element.dbId + "'>" + me.resources.delete + "</div></div>";
            }
            listElement = me.createListElements(element, sHTML);
            listElement.appendTo(list);

        });
                me.sendReportValidState(me.visual.find("#lst-missing li").length === 0);

        if (me.visual.find("#lst-missing li").length === 0) {
            me.visual.find("#lst-missing").html("<div class='note listNote'>" + me.resources.noErrors + "</div>");
        } else {
            list.html(list.find(".vc-list-item").sort(function(a, b) {
                return me.sortSheets(me, a, b);
            }));
        }

    } catch (ex) {
        me.writeError('ReportSheets.generateMissingElements', ex);
    }
};

ReportSheets.prototype.initClickHandler = function () {
    ///<summary>
    ///Initializes the clickable elements 
    ///</summary>
    var me = this;
    try {
        me.addSheetTitles();

        me.deleteFromPdfOutput();

        me.visual.find("#lst-used").off("change input keyup keydown",
            ".icon-checkbox, .excel-header-value").on("change input keyup keydown", ".icon-checkbox, .excel-header-value",
            function (element) {
                $(element.currentTarget).parents("li").find(".btn-save-sheet-option").toggle(true);
            });
         me.visual.find("#lst-available").off("click", ".btn-add-sheet-to-pdf").on("click", ".btn-add-sheet-to-pdf",function(event) {
                 me.addSheetToPDF($(event.currentTarget));
         });

         me.visual.find("#div-available").off("change", "#chb-available").on("change", "#chb-available", function () {
             try {
                 if ($(this)[0].checked === true) {
                     me.visual.find("#div-available .vc-list-item[data-internal='true']").show();
                 } else {
                     me.visual.find("#div-available .vc-list-item[data-internal='true']").hide();
                 }

                 if (me.visual.find("#div-available .vc-list-item:visible").length === 0) {
                     me.visual.find("#lst-available").append("<div class='note listNote'>" + me.resources.listEmpty + "</div>");
                 } else {
                     me.visual.find("#lst-available .note").remove();
                 }
             } catch (ex1) {
                 me.writeError(' ReportSheets.checkboxinternal', ex1);
             }
             }
         );
        me.visual.find("#lst-missing").off("click", ".btn-delete-from-db").on("click", ".btn-delete-from-db", function (element) {
            me.openAskDialog(me.resources.deleteConfirmText,
                { at: 'center center-20%', of: window },
                function() {

                    window.VisualCoreService.updateData(me.vcvid,
                        me.vcgid,
                        window.getCurrentTimestamp(),
                        0,
                        0,
                        me.param,
                        "",
                        me.deviceType,
                        me.langid,
                        JSON.stringify(me.createOptionObject(2, $(element.currentTarget))),
                        function(result) {
                            if (result.hasError !== false) {
                                $(element.currentTarget).parents("li").remove();
                                me.sendReportValidState(me.visual.find("#lst-missing li").length === 0);
                                if (me.visual.find("#lst-missing li").length === 0) {
                                    me.visual.find("#lst-missing")
                                        .html("<div class='note listNote'>" + me.resources.noEntriesExist + "</div>");
                                }
                            } else {
                                me.showInfo(result.retHTML, "", true);
                            }
                        });
                });
        });
         me.visual.find("#chb-available").show().trigger("change");

        me.visual.find("#lst-missing").off("click", ".btn-add-to-excel").on("click", ".btn-add-to-excel", function (event) {
             me.addSheetToExcel($(event.currentTarget));
         });

    } catch (ex) {
        me.writeError(' ReportSheets.initClickHandler', ex);
        return false;
    }
     return true;
};
ReportSheets.prototype.createOptionObject = function (updateType, button) {
    /**
    *  this function handles the creation of the option object for the webservice
    * @param {Int} updateType 
    * @param {HTmlElement} button 
    * @returns {Object containing the options for the webservice} 
    */
    var me = this;
    var retObj = {};
    var param;
    var autoDate, dictTitles;
    try {
        if (button.parents("li").find(".icon-checkbox").length > 0) {
            autoDate = button.parents("li").find(".icon-checkbox")[0].checked;
            dictTitles = {
                2: button.parents("li").find(".excel-header-value[data-langid=2]").val(),
                3: button.parents("li").find(".excel-header-value[data-langid=3]").val()
            };
        } else {
            autoDate = false;
            dictTitles = {
                2: button.data("name"),
                3: button.data("name")
            };
        }
        param = JSON.parse(me.param);
        retObj = {
            updateType: updateType,
            retID: button.data("id"),
            reportId: param.retID,
            sheetNames: button.data("name"),
            bAutomaticDate: autoDate,
            dictSheetTitles: dictTitles
        };
    } catch (ex) {
        me.writeError(' ReportSheets.createOptionObject', ex);
    }
    return retObj;
};
ReportSheets.prototype.addSheetToPDF = function (button) {
    ///<summary>
    /// this function handles the click event on the add to pdf icon
    ///</summary>
    var me = this;
    try {
        var used = me.sheetList.filter(function(inList) {
            return inList.dbId === button.data("id") && inList.excelName === button.data("name");
        });
        window.VisualCoreService.updateData(me.vcvid,me.vcgid,window.getCurrentTimestamp(),0,0,me.param,"",me.deviceType,me.langid,JSON.stringify(me.createOptionObject(4, button)),
            function(result) {
                if (result.hasError === false) {
                    button.parents("li").remove();
                    used[0].dbId = result.retID;
                    me.generateUsedElements(used, me.visual.find("#lst-used"));
                } else {
                    me.showInfo(result.retHTML, "", true);
                }
            });
    } catch (ex) {                                                                                         
        me.writeError(' ReportSheets.addSheetToPDF', ex);
    }
};
ReportSheets.prototype.addSheetToExcel = function (element) {
    ///<summary>
    /// this function handles the actual click of the add sheet to excel icon 
    ///</summary>
    var me = this;
    var addSheet, tmpListElement, currentListElement;
    try {
        addSheet = me.createOptionObject(1, element);
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, me.param, "", me.deviceType, me.langid, JSON.stringify(addSheet), function (result) {
            if (result.hasError === false) {
                currentListElement = element.parents("li");
                 tmpListElement = me.sheetList.filter(function (sheet) {
                    return sheet.excelName === addSheet.sheetNames;
                });
                me.generateAvailableElements(tmpListElement, me.visual.find("#lst-available"));
                currentListElement.remove();
                        me.sendReportValidState(me.visual.find("#lst-missing li").length === 0);

                if (me.visual.find("#lst-missing li").length === 0) {
                    me.visual.find("#lst-missing").html("<div class='note listNote'>" + me.resources.noEntriesExist + "</div>");
                }
            } else {
                me.showInfo(result.retHTML, "", true);
            }
        });
    } catch (exmissing) {
        me.writeError('ReportSheets.addSheetToExcel', exmissing);
    }
};
ReportSheets.prototype.sortSheets = function (me, a, b) {
    ///function to sort the sheets wether they are in use and then alphabetically
    ///if an error occurs all sheets are equal
    var ret = 0;
    var valueA, valueB;
    try {
        if ($(a).attr('data-internal') === $(b).attr('data-internal')) {
            valueA = $(a).attr('data-excelindex').toLowerCase().replace("_", " ").replace("ex", "");
            valueB = $(b).attr('data-excelindex').toLowerCase().replace("_", " ").replace("ex", "");
            if (valueA > valueB) ret = 1;
            if (valueA < valueB) ret = -1;
        } else if ($(a).attr('data-internal') === "true") {
            ret = 1;
        } else {
            ret = -1;
        }
    } catch (ex) {
        me.writeError("TemplateCreation.sortSheets", ex);
    }
    return ret;
};
ReportSheets.prototype.getLanguageText = function (langid) {
    ///<summary>
    /// this function returns the description for the text inputs of the used elements 
    /// <br /> based on the given langid
    ///</summary>
    var me = this;
    var sRet = "";
    try {
        switch (langid) {
            case 2:
                sRet = me.resources.titleDesc.replace("{0}", me.resources.german);
                break;
            case 3:
                sRet = me.resources.titleDesc.replace("{0}", me.resources.english);
                break;
        }
    } catch (ex) {
        me.writeError('ReportSheets.getLanguageText', ex);
    }
    return sRet;
};
ReportSheets.prototype.filter = function (list,filter) {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering analog signals.<br/>
    /// When a signal with a filter expression gets found the 'found' class gets added <br/>
    /// At the end, basically all 'found' classes get shown and all others hidden. The core of this function is taken from ARF<br/>
    /// </summary>
    var bRet = true;
    var me = this;
    try {
        if (me.error) {
            bRet = false;
        } else {
            //hide all
            me.visual.find(list +".vc-list-selection .vc-list-item").removeClass("found").data("counter", 0).hide();
            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(filter +".vc-filter",list + ".vc-list-selection .vc-list-item", "found");
            me.visual.find(list +".vc-list-selection .vc-list-item.found").show();
        }
    } catch (ex) {
        me.writeError('subSignalMenu.filter', ex);
        bRet = false;
    }
    return bRet;
};
